// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lfIg","top":"styles_top__1O3Io"};